import axios from "axios";

export const createLinkToken = async () => {
  try {
    const res: any = await axios.post(`/plaid/create-link-token`);
    return res?.data;
  } catch (e: any) {
    return e?.response?.data ? e.response.data : e;
  }
};

export const exchangePublicToken = async ({ publicToken, accountId }: { publicToken: string; accountId: string }) => {
  try {
    const res: any = await axios.post(`/plaid/exchange-public-token`, {
      publicToken,
      accountId,
    });
    return res?.data;
  } catch (e: any) {
    return e?.response?.data ? e.response.data : e;
  }
};

export const createACHPayment = async (data: any) => {
  try {
    const res: any = await axios.post(`/plaid/payment`, data);
    return res?.data;
  } catch (e: any) {
    return e?.response?.data ? e.response.data : e;
  }
};

export const createPlaidDepositPayment = async (data: { processorToken: string; amount: number; quoteId: string; quoteSequence?: number }) => {
  try {
    const res: any = await axios.post("/plaid/deposit-payment", data);
    return res?.data;
  } catch (e: any) {
    return e?.response?.data ? e.response.data : e;
  }
};
